import React, { useId } from 'react';
interface TooltipProps {
  content: string;
  side?: 'top' | 'bottom';
  align?: 'center' | 'end' | 'start';
  children: React.ReactNode;
}
const alignClasses = {
  center: 'left-1/2 -translate-x-1/2',
  end: 'right-0',
  start: 'left-0'
};
export function Tooltip({
  content,
  side = 'top',
  align = 'center',
  children
}: TooltipProps) {
  const id = useId();
  return <span className="group relative inline-flex rounded focus:outline-none focus-visible:ring-2 focus-visible:ring-sf-blue" tabIndex={0} aria-describedby={id} data-id="element-911" data-mp="39sxqr2i34efa">
      {children}
      <span id={id} role="tooltip" className={`pointer-events-none absolute z-40 w-max max-w-[260px] rounded bg-[#032D60] px-3 py-2 text-left text-xs font-normal leading-snug text-white opacity-0 shadow-lg transition-opacity duration-150 ease-out group-hover:opacity-100 group-focus:opacity-100 ${side === 'top' ? 'bottom-full mb-2' : 'top-full mt-2'} ${alignClasses[align]}`} data-id="element-912" data-mp="3epehm4go56w2">
        {content}
      </span>
    </span>;
}